import { render, staticRenderFns } from "./EscalaDolor.vue?vue&type=template&id=ba61306a&"
import script from "./EscalaDolor.vue?vue&type=script&lang=js&"
export * from "./EscalaDolor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports